var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"statisDiv",style:({width: _vm.width, height: _vm.height})},[_c('div',{staticClass:"totalDivClass"},[_c('div',{staticClass:"totalClass"},[_vm._v(_vm._s(_vm.totalText))]),_c('div',{staticClass:"companyClass"},[_vm._v(_vm._s(_vm.companyName))])]),_c('div',{staticClass:"describeClass"},[_vm._v(_vm._s(_vm.describeText))])])
}
var staticRenderFns = []

export { render, staticRenderFns }